/// <reference path="../../setup/_references.ts" />
module onvio.practice.widgets {
    'use strict';

    export interface IRecapSummaryV1Dto extends cs.IRecapSummaryV1Dto {
        /** Formatted amouint */
        amountFormatted?: string;
        /** Percentage (optional) */
        percentage?: string;
        /** Chart data */
        chart?: {
            lineStyle: any,
            percentileGroup?: string,
            tooltip?: string
        }
    }

    const POSITIVE_COLOR = '#005DA2';

    export class BmPracticeWidgetWIPSummary implements IBmPracticeWidgetService {

        /** Flag if the widget is busy */
        public isBusy: boolean = false;

        /** Ensure the invoice widgets refresh together */
        public coalescingServiceArea: string = 'invoices';

        /** Templates for the widget */
        public bodyTemplate: string = 'practice-widgets/wip-summary/wip-summary.html';
        public headerTemplate: string = 'practice-widgets/practice-widget-date-search-header.html';
        public searchBox: boolean = false;
        public size: WidgetSize = 'large';

        // /* i18nextract */'Bluemoon.Practice.Widget.WipSummary.BeginningBalance'
        // /* i18nextract */'Bluemoon.Practice.Widget.WipSummary.ProductionAmount'
        // /* i18nextract */'Bluemoon.Practice.Widget.WipSummary.BilledAmount'
        // /* i18nextract */'Bluemoon.Practice.Widget.WipSummary.AdjustmentAmount'
        // /* i18nextract */'Bluemoon.Practice.Widget.WipSummary.ProgressBilledAmount'
        // /* i18nextract */'Bluemoon.Practice.Widget.WipSummary.EndingBalance'
        public summaries: cs.INamedReferenceDto[] = [{
            id: 'beginningBalanceRecap',
            name: 'Bluemoon.Practice.Widget.WipSummary.BeginningBalance'
        }, {
            id: 'productionAmountRecap',
            name: 'Bluemoon.Practice.Widget.WipSummary.ProductionAmount'
        }, {
            id: 'billedAmountRecap',
            name: 'Bluemoon.Practice.Widget.WipSummary.BilledAmount'
        }, {
            id: 'adjustmentAmountRecap',
            name: 'Bluemoon.Practice.Widget.WipSummary.AdjustmentAmount'
        }, {
            id: 'progressBilledAmountRecap',
            name: 'Bluemoon.Practice.Widget.WipSummary.ProgressBilledAmount'
        }, {
            id: 'endingBalanceRecap',
            name: 'Bluemoon.Practice.Widget.WipSummary.EndingBalance'
        }];

        // /* i18nextract */'Bluemoon.Practice.Widget.Percentile.Unknown'
        // /* i18nextract */'Bluemoon.Practice.Widget.Percentile.Low'
        // /* i18nextract */'Bluemoon.Practice.Widget.Percentile.Average'
        // /* i18nextract */'Bluemoon.Practice.Widget.Percentile.High'
        public percentileGroups = {
            unknown: 'Bluemoon.Practice.Widget.Percentile.Unknown',
            low: 'Bluemoon.Practice.Widget.Percentile.Low',
            average: 'Bluemoon.Practice.Widget.Percentile.Average',
            high: 'Bluemoon.Practice.Widget.Percentile.High'
        }

        static $inject = [
            '$q',
            'csWipSummaryV2',
            '$translate',
            'bmpBigNumberUtils'
        ];
        constructor(
            private $q: ng.IQService,
            private dataService: cs.IWipSummaryV2Service,
            private $translate: ng.translate.ITranslateService,
            private bigNumber: bmp.globalize.IBigNumberUtils) {
            // Nothing required here
        }

        public initialize(widget: IBmPracticeWidgetController, done: () => void): void {
            // Remove the 'ALL' option as it's not appropriate
            widget.dateRangeSelectorOptions.shift();
            widget.loadDataArgs = { dateRangeId: 'MONTH' };
            done();
        }

        public loadData(args: IBmPracticeWidgetLoadDataArgs): ng.IPromise<any> {

            if (!args.dateRangeId || !args.startDate || !args.endDate) {
                return this.$q.when(undefined);
            }

            return this.dataService.get({
                clientId: args.contextId,
                startDate: args.startDate,
                endDate: args.endDate
            }).then((response: cs.IWipSummaryV2Dto & { [index: string]: IRecapSummaryV1Dto; }) => { // TODO - ng161 - handle reject from get
                // Generate a formatted version of each value
                _.forEach(this.summaries, (summary: cs.INamedReferenceDto) => {
                    response[summary.id].amountFormatted = this.bigNumber.formatDecimal(this.bigNumber.safeParseBigNumber(response[summary.id].amount || '0'), 'c');
                    // Generate chart data when there is a client
                    if (!!args.contextId) {
                        this._generateChartData(response[summary.id], response.percentileObservations);
                    }
                });
                return response;
            });

        }

        /**
         * Generates the chart data
         * @param data  Data object for the summary
         * @param observations Total number of observations
         */
        private _generateChartData(data: IRecapSummaryV1Dto, observations: number): void {

            // Special case, when there is no comparative data, don't show the chart.
            if (observations === 0) {
                return;
            }

            // Generate the default 'blank' chart data
            let chartData = {
                lineStyle: {
                    'background-color': POSITIVE_COLOR,
                    width: '0%',
                    height: '3px'
                },
                percentileGroup: this.percentileGroups.unknown,
                tooltip: undefined as string
            }
            data.chart = chartData;

            if (data.percentile) {
                let percentile = +data.percentile;
                chartData.lineStyle.width = `${percentile}%`;
                chartData.percentileGroup = percentile > 75 ? this.percentileGroups.high : percentile <= 25 ? this.percentileGroups.low : this.percentileGroups.average;
                chartData.tooltip = this.$translate.instant('Bluemoon.Practice.Widget.Percentile.PositionTooltip', { percentile: percentile });
            }

        }

    }

    angular.module('bm.practice.widgets.wipSummary', ['csWipSummaryV2', 'bm.practice.widgets.InvoiceService'])
        .service('bm-practice-widget-wip-summary', BmPracticeWidgetWIPSummary);
}
